import {useCallback} from 'react';
import axios from 'axios';

const POLL_INTERVAL_MS = 2500;
const POLL_TIMEOUT_MS = 60000;

export function useFetchUuid(apiUrl) {
  return useCallback(
    (email, requestUUID) => {
      return new Promise((resolve) => {
        const start = Date.now();

        const tick = () => {
          if (Date.now() - start >= POLL_TIMEOUT_MS) {
            resolve(undefined);
            return;
          }

          axios
            .post(`${apiUrl}/user/lookup`, {email, requestUUID}, {headers: {'Content-Type': 'application/json'}})
            .then(({data}) => {
              if (data.UUID) {
                resolve(data.UUID);
              } else {
                setTimeout(tick, POLL_INTERVAL_MS);
              }
            })
            .catch(() => {
              setTimeout(tick, POLL_INTERVAL_MS);
            });
        };

        setTimeout(tick, POLL_INTERVAL_MS);
      });
    },
    [apiUrl]
  );
}
